<template>
    <div>

        <div id="contact" class="section bg-svg-starrymountains">
            <div class="overlay opacity-75"></div>

            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-10">{{ this.header }}</h1>
                        <p class="lead mb-10">{{ this.subtext }}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'account-verify-email',
        metaInfo: {
            title: 'Verify Email',
            meta: [
                {
                    'name': 'robots',
                    'content': 'noindex'
                }
            ]
        },
        data () {
            return {
                "header": "Processing...",
                "subtext": "Please wait while we verify your email. This page will automatically update in a moment..."
            };
        },
        methods: {
        },
        computed: {
            "apiUrl": function(){
                return this.$root.apiBaseUrl + "/v1/account/email/verify";
            }
        },
        components: {
        },
        mounted(){
            if(!this.$route.query.token){
                this.header = "Error";
                this.subtext = "This email verification link is invalid.";
                return;
            }

            // use the properties in the querystring to call the API
            fetch(this.apiUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: this.$route.query.token
                })
            })
            .then(response => response.json()
                .then(data => ({ status: response.status, data }))
                .catch(() => ({ status: response.status, data: null }))
            )
            .then(({ status, data }) => {
                const isResent = !!(data && data.data && data.data.email_verify && data.data.email_verify.is_resent);

                if(status === 200){
                    this.header = "Thank you!";
                    this.subtext = "Your email address has been verified.";
                }else if(status === 403 && isResent){
                    this.header = "Link Expired";
                    this.subtext = "This verification link has expired, so we've sent a new one to your email. Please check your inbox.";
                }else if(status === 403){
                    this.header = "Link Expired";
                    this.subtext = "This verification link has expired.";
                }else if(status === 404 || status === 400){
                    this.header = "Error";
                    this.subtext = "This email verification link is invalid.";
                }else{
                    this.header = "Error";
                    this.subtext = "Something went wrong on our end. Please try again later.";
                }
            })
            .catch(() => {
                this.header = "Error";
                this.subtext = "Something went wrong. Please check your connection and try again.";
            });
        }
    }
</script>
